import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFF',
    paddingTop: 18,
    paddingHorizontal: 16,
  },
  topBar: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 20,
  },
  brand: {
    fontSize: 18,
    fontWeight: '700',
    color: '#2563EB',
    marginBottom: 8,
  },
  greeting: {
    fontSize: 24,
    fontWeight: '800',
    color: '#111827',
  },
  date: {
    marginTop: 4,
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 10,
  },
  profileBubble: {
    width: 42,
    height: 42,
    borderRadius: 21,
    backgroundColor: '#6366F1',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileInitials: {
    color: '#fff',
    fontWeight: '700',
    fontSize: 15,
  },
  scrollContent: {
    paddingBottom: 24,
    margin : 5
  },
  primaryCard: {
    backgroundColor: '#1D4ED8',
    borderRadius: 22,
    paddingVertical: 28,
    paddingHorizontal: 18,
    alignItems: 'center',
    marginBottom: 18,
  },
  primaryIcon: {
    width: 48,
    height: 48,
    borderRadius: 24,
    backgroundColor: 'rgba(255,255,255,0.18)',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 16,
  },
  primaryTitle: {
    color: '#fff',
    fontSize: 22,
    fontWeight: '800',
  },
  primarySubtitle: {
    marginTop: 6,
    color: 'rgba(255,255,255,0.9)',
    fontSize: 14,
    fontWeight: '500',
  },
  sectionLabel: {
    fontSize: 12,
    fontWeight: '700',
    color: '#9CA3AF',
    marginBottom: 10,
    textTransform: 'uppercase',
    letterSpacing: 0.4,
  },

  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.15)',
  },
  menuContainer: {
    position: 'absolute',
    top: 70,
    right: 15,
    width: 240,
    backgroundColor: '#FFF',
    borderRadius: 16,
    paddingVertical: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.15,
    shadowRadius: 8,
    elevation: 8,
  },
  menuItem: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 18,
    paddingVertical: 16,
  },
  menuText: {
    marginLeft: 12,
    fontSize: 15,
    color: '#384454',
    fontWeight: '500',
  },
  separator: {
    height: 1,
    backgroundColor: '#ECECEC',
    marginVertical: 4,
  },

  biometricDialogContent: {
    alignItems: 'center',
    gap: 16,
  },
  biometricText: {
    textAlign: 'center',
    fontSize: 15,
    color: '#374151',
  },
  biometricActions: {
    flexDirection: 'row',
    gap: 12,
    width: '100%',
  },
  biometricButtonSecondary: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    backgroundColor: '#F3F4F6',
  },
  biometricButtonPrimary: {
    flex: 1,
    paddingVertical: 12,
    borderRadius: 8,
    alignItems: 'center',
    backgroundColor: '#1D4ED8',
  },
  biometricButtonTextSecondary: {
    color: '#374151',
    fontWeight: '600',
  },
  biometricButtonTextPrimary: {
    color: '#fff',
    fontWeight: '600',
  },
})
